import {FC, ReactNode} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router-dom'
import {checkIsActive, KTIcon, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'
import {Button} from 'react-bootstrap' // Added import for Button
import { useAppSelector } from 'src/redux/storeHooks'
import { useFreeTrialDeferredOnboarding } from 'src/hooks/useFreeTrialDeferredOnboarding'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type Props = {
  to: string
  title: string
  icon?: string
  alternateIcon?: any
  fontIcon?: string
  loader?: boolean
  hasBullet?: boolean
  onClick?: () => void // Added optional onClick prop
  badge?:boolean
  requiresSubscription?: boolean
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  alternateIcon,
  fontIcon,
  loader,
  hasBullet = false,
  onClick, // Added onClick prop
  badge,
  requiresSubscription = true
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {app} = config
  const { fetchedUserAccountData } = useAppSelector(state=>state.userAccountData)
  const { isDeferredFreeTrialOnboarding, handleDeferredNavClick } = useFreeTrialDeferredOnboarding()

  const isSubscriptionUnlocked =
    !!fetchedUserAccountData?.is_subscribed && !!fetchedUserAccountData?.isOnboardingProcessCompleted
  const isPricingContext = window.location.pathname == '/pricing' && to.includes('/pricing')
  const isLinkEnabled = requiresSubscription
    ? isSubscriptionUnlocked || isPricingContext || isDeferredFreeTrialOnboarding
    : true
  const titleClassName = isLinkEnabled ? 'menu-title' : 'menu-title text-secondary'
  const buttonEnabled = requiresSubscription
    ? isSubscriptionUnlocked || isDeferredFreeTrialOnboarding
    : true
  

  return (
    <div className='menu-item'>
      {onClick ? ( // Render Button if onClick is provided
        <Button
          onClick={onClick}
          variant='link'
          className={`menu-item ms-3 d-flex py-1 align-items-center ${loader ? 'disabled' : ''}`}
          style={{
            textDecoration: 'none',
            color: (buttonEnabled || title === 'Discogs Integration') ? 'white' : '#8E9BAA',
            fontWeight: 'bold'
          }} // Added styles
          disabled={
            title === 'Discogs Integration'
              ? false
              : !(buttonEnabled && loader === false)
          }
            >
          {icon && (
            <span className='menu-icon '>
              {/* Assuming you have an icon rendering mechanism */}
              <KTIcon iconName={icon} className='fs-2' />
            </span>
          )}
          {!icon&& alternateIcon && <span className='menu-icon'>{alternateIcon}</span>}
          {/* <span className='menu-title ms-2' style={{fontSize: '16px', paddingTop: '-10px'}}> */}
          <p className='menu-title ms-2 mb-0 ' style={{fontSize: '16px'}}>
            {' '}
            {title}{' '}
          </p>
          {/* </span> */}
        </Button>
      ) : (
        // Render Link for navigation if no onClick
        <Link
          className={clsx('menu-link without-sub', {active: isActive})}
          to={to}
          onClick={(event) => {
            if (isDeferredFreeTrialOnboarding && to !== '/support') {
              handleDeferredNavClick(event)
            }
          }}
          style={{
            textDecoration: 'none',
            pointerEvents: isLinkEnabled ? 'auto' : 'none'
          }}
        >
          {hasBullet && (
            <span className='menu-bullet'>
              <span className='bullet bullet-dot'></span>
            </span>
          )}
          {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
            <span className='menu-icon '>
              {' '}
              <KTIcon iconName={icon} className='fs-2' />
            </span>
          )}
           {alternateIcon &&  <span className='menu-icon' ><FontAwesomeIcon icon={alternateIcon} size="xl" /></span>}


           
          {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
            <i className={clsx('bi fs-3', fontIcon)}></i>
          )}
          <span
            className={titleClassName}
            style={{
              fontSize: '16px',
              fontWeight: 'bold',
              color: isLinkEnabled ? undefined : '#8E9BAA'
            }}
          >
            {/* { badge ? badge : null} */}
            {title}
          </span>
        </Link>
      )}
      {children}
    </div>
  )
}

export {SidebarMenuItem}
